import { buildDeliveryNoteUnitOptions } from './deliveryNoteUnits';

const STANDARD_UNITS = {
  kg: ['kg', 1, 'weight'], kilogram: ['kg', 1, 'weight'], kilogramo: ['kg', 1, 'weight'],
  g: ['kg', 0.001, 'weight'], gram: ['kg', 0.001, 'weight'], gramo: ['kg', 0.001, 'weight'],
  l: ['l', 1, 'volume'], liter: ['l', 1, 'volume'], litre: ['l', 1, 'volume'], litro: ['l', 1, 'volume'],
  ml: ['l', 0.001, 'volume'], milliliter: ['l', 0.001, 'volume'], millilitre: ['l', 0.001, 'volume'], mililitro: ['l', 0.001, 'volume'],
  cl: ['l', 0.01, 'volume'], centiliter: ['l', 0.01, 'volume'], centilitro: ['l', 0.01, 'volume'],
  unit: ['unit', 1, 'count'], unidad: ['unit', 1, 'count'], ud: ['unit', 1, 'count'],
};

// Only unit definitions and configured pack factors are used, never product names.
export function configuredEquivalentFactors(item) {
  const candidates = {};
  for (const option of buildDeliveryNoteUnitOptions(item)) {
    const definition = item[option.level];
    const key = String(definition?.code || definition?.name || option.label || '').trim().toLowerCase();
    const standard = STANDARD_UNITS[key];
    if (!standard || (definition?.type && definition.type !== standard[2])) continue;
    const factor = Number((option.factor * standard[1]).toFixed(8));
    if (!(factor > 0 && factor < 1e12)) continue;
    (candidates[standard[0]] ||= []).push(factor);
  }
  return Object.fromEntries(Object.entries(candidates)
    .filter(([, factors]) => factors.every((factor) => factor === factors[0]))
    .map(([unit, factors]) => [unit, factors[0]]));
}

export function suggestedEquivalentUnit(items) {
  if (!items.length) return '';
  return ['kg', 'l', 'unit'].find((unit) => items.every((item) => configuredEquivalentFactors(item)[unit] !== undefined)) || '';
}

export function validEquivalentFactor(value) {
  if (String(value).trim() === '') return false;
  const factor = Number(value);
  return Number.isFinite(factor) && factor > 0 && factor < 1e12 && Number(factor.toFixed(8)) === factor;
}
